import React, { ReactNode, useEffect, useState } from "react"
import { TableRow } from "./TableRow"
import TableCardSkeleton from "./TableCardSkeleton"

type Row = ReactNode[]
type Table = Row[]

interface TableCardProps {
  tables: Table[]
  tabIndex: number
  onFocus: () => void
  loading?: boolean
  tableId?: string
  ariaLabel?: string
}

const TableCards: React.FC<TableCardProps> = ({
  tables,
  tabIndex,
  onFocus,
  loading,
  tableId,
  ariaLabel,
}) => {
  const [tableTabIndex, setTableTabIndex] = useState(tabIndex)

  useEffect(() => {
    setTableTabIndex(tabIndex)
  }, [tabIndex])

  return loading ? (
    <TableCardSkeleton />
  ) : (
    <div id={tableId}>
      {tables.map((table, tableIdx) => {
        return (
          <div
            className="overflow-hidden min-w-[240px] border border-solid border-[1px] border-gray-200 rounded-lg mb-2 bg-white overflow-hidden"
            key={`table-card-${tableIdx}`}
          >
            <table
              className="w-full table-fixed border-spacing-0"
              aria-label={ariaLabel ?? "Row details"}
              tabIndex={tableTabIndex}
              onFocus={onFocus}
            >
              <tbody>
                {table.map((row, rowIdx) => {
                  let tableRows = [] as ReactNode[][]
                  const isGroupHeader = row.length === 1
                  const className = isGroupHeader
                    ? "font-medium text-gray-700 !min-w-[240px] bg-[#FAFAFA] hover:bg-[#FAFAFA]"
                    : "!min-h-[31px] !min-w-[240px] items-center"

                  tableRows.push([
                    <TableRow
                      id={`table-${tableIdx}-row-${rowIdx}`}
                      key={`table-${tableIdx}-row-${rowIdx}`}
                      className={className}
                    >
                      {row}
                    </TableRow>,
                  ])

                  return tableRows
                })}
              </tbody>
            </table>
          </div>
        )
      })}
    </div>
  )
}

export default TableCards
